import Tag, { type TagProps } from '@cobliteam/ui/components/Tag';

const New = (props: TagProps) => {
  return <Tag label={props.label || 'Novo'} {...props} color='success' />;
};

const Beta = (props: TagProps) => {
  return <Tag label={props.label || 'Beta'} {...props} color='primary' />;
};

export default {
  New,
  Beta,
};
